<template>
  <modal
    id="closereasonmodal"
    v-if="project.id"
    :show="project.id"
    :closeOnbackdrop="false"
    class="closereasonmodal"
    @close="handleClose">
    <template slot="header">
      <h4 style="color: white;">Close Reason ({{ project.quote_number }})</h4>
    </template>
    <template>
      <form
        ref="closeReasonForm"
        class="closeReasonForm"
        autocomplete="off"
        @submit.prevent="handleClickSave">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 col-lg-12">
                <h3 class="creason">
                  Choose/Specify Reason:
                </h3>
                <div class="radio">
                  <label for="reason-crpe"><input id="reason-crpe" ref="reason_crpe" v-model="currentProject.close_reason" type="radio" name="close_reason" value="Purchased Elsewhere" required @change="reasonChange"> Purchased Elsewhere</label>
                </div>
                <div class="radio">
                  <label for="reason-crlj"><input id="reason-crlj" ref="reason_crlj" v-model="currentProject.close_reason" type="radio" name="close_reason" value="Lost Job" required @change="reasonChange"> Lost Job</label>
                </div>
                <div class="radio">
                  <label for="reason-crrem"><input id="reason-crrem" ref="reason_crrem" v-model="currentProject.close_reason" type="radio" name="close_reason" value="Refurbished Existing Machine" required @change="reasonChange"> Refurbished Existing Machine</label>
                </div>
                <div class="radio">
                  <label for="reason-crd"><input id="reason-crd" ref="reason_crd" v-model="currentProject.close_reason" type="radio" name="close_reason" value="Duplicate" required @change="reasonChange"> Duplicate</label>
                </div>
                <div class="radio">
                  <label for="reason-errin"><input id="reason-errin" ref="reason-errin" v-model="currentProject.close_reason" type="radio" name="close_reason" value="Error in Inputs" required @change="reasonChange"> Error in Inputs</label>
                </div>
                <div class="radio">
                  <label for="reason-cro"><input id="reason-cro" ref="reason_cro" v-model="currentProject.close_reason" type="radio" name="close_reason" value="Other" required @change="reasonChange"> Other</label>
                </div>
                <div>
                  <input ref="close_reason_input" v-model="currentProject.close_res" :type="currentProject.close_reason === 'Other' ? 'text' : 'hidden'" :required="currentProject.close_reason === 'Other'" class="form-control" maxlength="100" placeholder="Specify reason">
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template slot="footer">
      <template>
        <a :disabled="isSaving" class="btn btn-black" @click="handleClose">Cancel</a>
        <a :disabled="isSaving" class="btn btn-black" @click="handleClickSave">
          <template v-if="isSaving"><span class="fa fa-spinner fa-pulse"></span> Closing...</template>
          <template v-else>Close Project</template>
        </a>
      </template>
    </template>
  </modal>
</template>
<script>
export default {
  name: 'CloseReasonModal',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentProject: {
        id: this.project.id,
        close_reason: null,
        close_res: null
      },
      isSaving: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
      this.currentProject = {}
    },
    checkData(){
      let hasEmpty = false,
        firstEl = false;

      if (this.currentProject.close_reason === 'Other') {
        const el = this.$refs['close_reason_input'];
        if (el.required && (el.value === '' || el.value === undefined)) {
          hasEmpty = true;
          if ( !firstEl ) firstEl = el;
          el.classList.add('has-error');
        } else {
          if (el.classList.contains('has-error')) {
            el.classList.remove('has-error');
          }
        }
      }
      if ( hasEmpty ) {
        alert('Please fill input detail.');
        firstEl.focus();
        return false;
      }
      if (this.currentProject.close_reason === null) {
        alert('Please select an answer.');
        return false;
      }
      return true;
    },
    handleClickSave() {
      if ( !this.checkData() ) {
        this.isSaving = false;
        return false;
      }
      const subapi = (this.project.phase == 'spareparts') ? 'spare-parts/close' : 'close' ;
      const api = `/api/${subapi}/ ${this.project.id}`;
      this.isSaving = true;
      this.$http.post(api, this.currentProject).then(() => {
        this.isSaving = false;
        this.handleUpdated();
      }).catch(error => {
        console.log(error);
        this.isSaving = false;
      })
    },
    handleUpdated() {
      this.$emit('updated')
      this.currentProject = {}
    },
    reasonChange(event) {
      if (event.target.value !== 'Other') {
        this.currentProject.close_res = null
      }
    }
  }
}
</script>
<style>
  .closeReasonForm .has-error{
    outline: 1px solid red !important;
    z-index: 2 !important;
    background: #ffe9e9 !important;
    border-color: red !important;
  }
  .creason {
    color: black !important;
  }
  .closereasonmodal .modal-body {
    height: 244px !important;
  }
</style>